var _style, _defs, _defs2, _defs3, _rect, _defs4, _defs5, _rect2, _defs6, _defs7, _path, _defs8, _defs9, _rect3, _defs10, _defs11, _rect4, _defs12, _defs13, _rect5, _defs14, _defs15, _rect6, _defs16, _defs17, _rect7, _defs18, _defs19, _rect8, _defs20, _defs21, _rect9, _defs22, _defs23, _rect10, _defs24, _defs25, _rect11, _defs26, _defs27, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 156 128"
    },
    viewBox: "0 0 156 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_4_);}\n\t.st2{clip-path:url(#SVGID_6_);fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_8_);}\n\t.st4{clip-path:url(#SVGID_10_);fill:#E6772F;}\n\t.st5{clip-path:url(#SVGID_12_);}\n\t.st6{clip-path:url(#SVGID_14_);fill:none;stroke:#CBCBCB;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{clip-path:url(#SVGID_16_);}\n\t.st8{clip-path:url(#SVGID_18_);fill:#1A1919;}\n\t.st9{clip-path:url(#SVGID_20_);}\n\t.st10{clip-path:url(#SVGID_22_);fill:#1A1919;}\n\t.st11{clip-path:url(#SVGID_24_);}\n\t.st12{clip-path:url(#SVGID_26_);fill:#1A1919;}\n\t.st13{clip-path:url(#SVGID_28_);}\n\t.st14{clip-path:url(#SVGID_30_);fill:#1A1919;}\n\t.st15{clip-path:url(#SVGID_32_);}\n\t.st16{clip-path:url(#SVGID_34_);fill:#1A1919;}\n\t.st17{clip-path:url(#SVGID_36_);}\n\t.st18{clip-path:url(#SVGID_38_);fill:#1A1919;}\n\t.st19{clip-path:url(#SVGID_40_);}\n\t.st20{clip-path:url(#SVGID_42_);fill:#1A1919;}\n\t.st21{clip-path:url(#SVGID_44_);}\n\t.st22{clip-path:url(#SVGID_46_);fill:#E6772F;}\n\t.st23{clip-path:url(#SVGID_48_);}\n\t.st24{clip-path:url(#SVGID_50_);fill:#1A1919;}\n\t.st25{clip-path:url(#SVGID_52_);}\n\t.st26{clip-path:url(#SVGID_54_);fill:#1A1919;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.9,30c0-3.3,2.7-6,6-6h116c3.3,0,6,2.7,6,6v68c0,3.3-2.7,6-6,6h-116c-3.3,0-6-2.7-6-6V30z",
    id: "SVGID_1_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 90,
    id: "SVGID_3_",
    width: 138,
    x: 8.9,
    y: 19
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_3_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_5_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_5_"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 90,
    width: 138,
    x: 8.9,
    y: 19
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M141.5,67.7c0,0-34.7,24.5-98.3,35.4h98.3V67.7",
    id: "SVGID_7_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_7_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_9_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_9_"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 45.4,
    width: 108.3,
    x: 38.2,
    y: 62.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.9,30c0-3.3,2.7-6,6-6h116c3.3,0,6,2.7,6,6v68c0,3.3-2.7,6-6,6h-116c-3.3,0-6-2.7-6-6V30z",
    id: "SVGID_11_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_11_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_13_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_13_"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M13.9,30c0-3.3,2.7-6,6-6h116c3.3,0,6,2.7,6,6v68c0,3.3-2.7,6-6,6h-116c-3.3,0-6-2.7-6-6V30z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.9,47.7h-5.3v18.4h5.2c2.8,0,4.8-0.7,6.6-2.1c2.1-1.7,3.3-4.4,3.3-7.1       C34.8,51.5,30.7,47.7,24.9,47.7z M29.1,61.5c-1.1,1-2.6,1.5-4.9,1.5h-1V50.8h1c2.3,0,3.7,0.4,4.9,1.5c1.2,1.1,2,2.8,2,4.6       C31.1,58.7,30.3,60.4,29.1,61.5z",
    id: "SVGID_15_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_15_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_17_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_17_"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    height: 28.4,
    width: 25.2,
    x: 14.6,
    y: 42.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 18.4,
    id: "SVGID_19_",
    width: 3.6,
    x: 36.8,
    y: 47.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_19_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_21_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_21_"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    height: 28.4,
    width: 13.6,
    x: 31.8,
    y: 42.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.2,55.1c-2.2-0.8-2.8-1.3-2.8-2.3c0-1.2,1.1-2,2.7-2c1.1,0,2,0.4,2.9,1.5l1.9-2.5       c-1.5-1.4-3.4-2-5.4-2c-3.3,0-5.7,2.3-5.7,5.3c0,2.5,1.2,3.8,4.5,5.1c1.4,0.5,2.1,0.8,2.5,1.1c0.7,0.5,1.1,1.1,1.1,1.9       c0,1.5-1.2,2.6-2.8,2.6c-1.7,0-3.1-0.9-3.9-2.5l-2.3,2.2c1.7,2.4,3.6,3.5,6.4,3.5c3.7,0,6.4-2.5,6.4-6.1       C54.5,57.9,53.3,56.6,49.2,55.1",
    id: "SVGID_23_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_23_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_25_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_25_"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    height: 29.2,
    width: 22.7,
    x: 36.8,
    y: 42.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.4,56.6c0,5.4,4.3,9.6,9.7,9.6c1.5,0,2.9-0.3,4.5-1.1v-4.2c-1.4,1.4-2.7,2-4.3,2       c-3.6,0-6.2-2.6-6.2-6.3c0-3.5,2.6-6.3,6-6.3c1.7,0,3,0.6,4.5,2.1v-4.2C68,47.3,66.7,47,65.2,47C59.7,47,55.4,51.3,55.4,56.6",
    id: "SVGID_27_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_27_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_29_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_29_"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st14",
    height: 29.2,
    width: 24.2,
    x: 50.4,
    y: 42
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_31_",
    points: "98.5,60.1 93.6,47.7 89.7,47.7 97.5,66.6 99.4,66.6 107.4,47.7 103.5,47.7 98.5,60.1      "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_31_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_33_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_33_"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    height: 28.9,
    width: 27.7,
    x: 84.7,
    y: 42.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_35_",
    points: "109,66.1 119.2,66.1 119.2,63 112.6,63 112.6,58 118.9,58 118.9,54.9 112.6,54.9 112.6,50.8        119.2,50.8 119.2,47.7 109,47.7 109,66.1      "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_35_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_37_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_37_"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    height: 28.4,
    width: 20.2,
    x: 104,
    y: 42.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.7,53.1c0-3.4-2.4-5.4-6.5-5.4h-5.3v18.4h3.6v-7.4h0.5l5,7.4h4.4l-5.8-7.8       C132.2,57.8,133.7,55.9,133.7,53.1z M126.5,56.2h-1v-5.6h1.1c2.2,0,3.4,0.9,3.4,2.7C130,55.2,128.8,56.2,126.5,56.2z",
    id: "SVGID_39_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_39_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_41_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_41_"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    height: 28.4,
    width: 23.4,
    x: 116.9,
    y: 42.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.3,56.6c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6       C86,47,90.3,51.3,90.3,56.6",
    id: "SVGID_43_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_43_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_45_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_45_"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    height: 29.2,
    width: 29.2,
    x: 66.1,
    y: 42
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.9,48.2c0-0.3-0.2-0.5-0.6-0.5h-0.5v1.7h0.4v-0.7l0.5,0.7h0.5l-0.6-0.7       C135.8,48.6,135.9,48.5,135.9,48.2z M135.2,48.5L135.2,48.5l-0.1-0.4h0.1c0.2,0,0.3,0.1,0.3,0.2       C135.5,48.4,135.4,48.5,135.2,48.5z",
    id: "SVGID_47_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_47_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_49_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_49_"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    height: 11.7,
    width: 11.4,
    x: 129.7,
    y: 42.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.5,47c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5       C137,47.7,136.3,47,135.5,47z M135.5,49.7c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2c0.6,0,1.2,0.6,1.2,1.2       C136.7,49.1,136.2,49.7,135.5,49.7z",
    id: "SVGID_51_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_51_"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 80,
    id: "SVGID_53_",
    width: 128,
    x: 13.9,
    y: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_53_"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "st26",
    height: 13,
    width: 13,
    x: 129,
    y: 42
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.ac74ba158cf1f80e5a49738e3bb368a7.svg";
export { ForwardRef as ReactComponent };